import React from 'react'
import HeaderSection from './header/header'
import PhotoGallery from './PhotoGallery'
import PropertyDetails from './PropertyDetails/detail'
import PropertyInfo from './PropertyDetails/PropertyInfo'
import ContactSection from './PropertyDetails/ContactSection'
import MoreDetailsSection from './moreDetails/MoreDetails'
import AboutProject from './AboutProject/AboutProject'
import AmenitiesSection from './Amenities/Amenities'
import OtherPropertiesSection from './OtherProperties/OtherProperties'

const LeftSection = ({propertyData}) => {

  console.log("propertyData",propertyData);
  


  return (
    <div className='ml-0 lg:ml-8 px-4 sm:px-6 lg:px-0  '>
      <div className='border rounded-lg overflow-hidden'>
      <HeaderSection
        Price={propertyData?.pricingAndOthers?.OwnershipPriceDetails?.expectedPrice || ""}
        EMI={propertyData?.emi || {}}
        Title={propertyData?.title || ""}
        propertyData={propertyData}
      />
        <div className='flex flex-col md:flex-row'>
          <div className='w-full md:w-[40%] px-2 md:px-0 border bg-white'>
          <PhotoGallery images={propertyData?.mediaFiles || []}/>
          </div>
          <div className='w-full md:w-[60%] px-2 bg-white'>
          <PropertyDetails
            furnishedStatus={propertyData?.aboutProperty?.furnishings?.status}
            carParking={propertyData?.aboutProperty?.parking?.coveredParking}
            bedrooms={propertyData?.aboutProperty?.roomDetails?.bedrooms}
            bathrooms={propertyData?.aboutProperty?.roomDetails?.bathrooms}
            balconies={propertyData?.aboutProperty?.roomDetails?.balconies}
            
          />
          <PropertyInfo 
            propertyData={propertyData}


          />
          </div>
        </div>
        <ContactSection/>
      </div>
        <div className='border my-3 rounded-lg'>
            <MoreDetailsSection propertyData={propertyData}/>
        </div>
       {propertyData?.aboutProject && <div className='border my-3 rounded-lg'>
          <AboutProject/>
        </div>}
        <div className='border my-3 rounded-lg'>
          <AmenitiesSection PropertyFeatures={propertyData?.pricingAndOthers?.PropertyFeatures}/>
        </div>
        <div className='border my-3 rounded-lg'>
          <OtherPropertiesSection/>
        </div>
    </div>
  )
}

export default LeftSection
